import useInteractionTracker from '@blueshift-ui/telemetry/dist/hooks/use-interaction-tracker';
import Link from 'next/link';

export default function SimpleFooter() {
  const { trackEvent } = useInteractionTracker();

  return (
    <footer className="mt-auto bg-footer border-t border-footer-border py-4">
      <div className="container mx-auto px-4 text-center">
        <p className="text-sm text-secondary">
          <span className="hidden sm:inline">Powered by </span>
          <Link
            className="text-brand-primary hover:text-interactive-primary transition-colors duration-200 font-medium"
            href="https://www.varsitytutors.com"
            onClick={() =>
              void trackEvent({ action: 'click-footer-link', category: 'footer', label: 'varsity-tutors' })
            }
            prefetch={false}
            target="_blank"
          >
            Varsity Tutors
          </Link>{' '}
          &sdot; &copy; {new Date().getFullYear()} All Rights Reserved
        </p>
      </div>
    </footer>
  );
}
